import React from 'react';
import s from './Settings.module.scss'
type SettingsType = {

}

export const Settings = (props: SettingsType) => {
	return (
		<>
			<div>В стадии наполнения</div>
		</>
	);
};